var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4519",
    "data-name": "Rectangle 4519",
    width: 20,
    height: 20,
    transform: "translate(50 183)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-50 -183)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "categories",
    d: "M11.6,4.4V10A1.6,1.6,0,0,1,10,11.6H4.4A1.6,1.6,0,0,1,2.8,10V4.4A1.6,1.6,0,0,1,4.4,2.8H10A1.6,1.6,0,0,1,11.6,4.4Zm9.6-1.6H15.6A1.6,1.6,0,0,0,14,4.4V10a1.6,1.6,0,0,0,1.6,1.6h5.6A1.6,1.6,0,0,0,22.8,10V4.4A1.6,1.6,0,0,0,21.2,2.8ZM10,14H4.4a1.6,1.6,0,0,0-1.6,1.6v5.6a1.6,1.6,0,0,0,1.6,1.6H10a1.6,1.6,0,0,0,1.6-1.6V15.6A1.6,1.6,0,0,0,10,14Zm8.4,0a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,18.4,14Z",
    transform: "translate(47.2 180.2)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.b8ae0c7fcf99fe318c37c9e37a912236.svg";
export { ForwardRef as ReactComponent };